import { EMPTY_MASTER_CALENDAR_EVENTANY_MODEL } from "presentation/model/CalendarEvent/CalendarEventMaintenanceModel"; 
import { useState } from "react"; 
import { createContainer } from "react-tracked"; 
const { 
    Provider: CalendarEventMaintenanceProvider, 
    useTracked: useCalendarEventMaintenanceTracked 
} = createContainer(() => useState(EMPTY_MASTER_CALENDAR_EVENTANY_MODEL), {concurrentMode: true}); 
export { CalendarEventMaintenanceProvider, useCalendarEventMaintenanceTracked }; 
